import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useRequest } from "ahooks";
import AuthLayout from "../../layouts/AuthLayout";
import { toast } from "react-toastify";
import { useUser } from "../../contexts";
import { checkOrder, getLoginToken } from "../../api";
import { useTranslation } from "react-i18next";
import { Button, Text, TextInput } from "@mantine/core";
import { ChooseUploadType } from "../../interfaces";
const Login: React.FC = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const [, dispatchUser] = useUser();
  const [correctEmail, setCorrectEmail] = useState<string>();
  // Verwende das useLocation Hook, um auf die Query-Parameter zuzugreifen
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const orderNumberFromQueryParam = queryParams.get("orderNumber");
  const emailFromQueryParam = queryParams.get("email");

  // Falls Query-Parameter vorhanden sind, kannst du sie in den TextInput-Komponenten vorfüllen
  // Falls Query-Parameter vorhanden sind, kannst du sie in den TextInput-Komponenten vorfüllen
  const orderNumberDefaultValue = orderNumberFromQueryParam || "";
  const emailDefaultValue = emailFromQueryParam || "";

  const handleLogin = async ({
    email,
    orderNumber,
  }: {
    email: string;
    orderNumber: string;
  }) => {
    try {
      const token = await getLoginToken(email, orderNumber);
      if (!token) {
        toast.error("order");
        setCorrectEmail(undefined);
        return;
      }
      localStorage.setItem("token", token);
      let order = await checkOrder();

      if (!order) {
        toast.error(t("orderNotFound"));
        return;
      }
      setCorrectEmail(undefined);
      dispatchUser({
        type: "UPDATE",
        order,
      });
      toast.success(t("loginSuccess"));
     if (order.chooseUpload === ChooseUploadType.bulkUpload) {
        history.push("/account/bulkupload");
      } else {
      history.push("/account");
    }
    } catch (err: any) {
      if (err.email) {
        setCorrectEmail(err.email);
      }
      toast.error(t(err?.message ?? "orderNotFound"));
      return false;
    }
    return true;
  };

  const loginAction = useRequest((values) => handleLogin(values), {
    manual: true,
  });

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    const email = e.target["email"].value;
    const orderNumber = e.target["orderNumber"].value.replace(/\s+/g, "");
    loginAction.run({ email, orderNumber });
  };

  return (
    <AuthLayout>
      <div className="card">
        <div className="text-center mb-20">
          <p style={{ fontSize: 22 }} className="f-w-500">
            {t("loginText")}
          </p>
        </div>
        <form className="form" onSubmit={handleSubmit}>
          <div className="form__row">
            <Text>{t("orderNumber")}</Text>
            <TextInput
              name="orderNumber"
              type="text"
              required
              //pattern="\S+"
              placeholder={t("orderNumber")}
              defaultValue={orderNumberDefaultValue}
            />
          </div>
          <div className="form__row">
            <Text>{t("email")}</Text>
            <TextInput
              name="email"
              type="email"
              required
              placeholder={t("email")}
              defaultValue={emailDefaultValue}
            />
          </div>
          <div className="form__row">
            <Button
              size="lg"
              loading={loginAction.loading}
              disabled={loginAction.loading}
              className="form-control mt-10"
              fullWidth
              type="submit"
            >
              {t("login")}
            </Button>
          </div>

          {correctEmail && (
            <p>
              {t("userDataDoesNotMatch")} <br /> {correctEmail}
            </p>
          )}
        </form>
      </div>
    </AuthLayout>
  );
};

export default Login;
